import React from "react";
import "./blogdetail.css";
import Topbar from "../../components/Topbar/Topbar";
import Footer from "../../components/Footer/Footer";
import BlogDetails from "../../components/BlogDetails/BlogDetails";

const BlogDetail = () => {
    return (
        <>
            <Topbar />
            <div className="BlogDetail-container">
                <BlogDetails />
                <Footer />
            </div>
        </>
    )
}

export default BlogDetail;